
$(document).ready(function () 
{
    
    var type = $(".effects_type").attr('data-effects') || 'snow';
    var snow_color = $(".effects_type").attr('data-snow_color') || '#ddd5d5';

    if(type == 'none')
    {
        return;
    }
    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }
    
    switch(type) {
        case 'basic_cannon':
          if (window.confetti) {
            window.confetti({
              particleCount: 100,
              spread: 70,
              origin: { y: 0.6 }
            });
          }
          return;
        case 'random':
            
          if (window.confetti) {
            window.confetti({
              angle: randomInRange(55, 125),
              spread: randomInRange(50, 70),
              particleCount: randomInRange(50, 100),
              origin: { y: 0.6 }
            });
          }
          return;
        case 'realistic':
          if (window.confetti) {
            var count = 200;
            var defaults = {
              origin: { y: 0.7 }
            };

            function fire(particleRatio, opts) {
              confetti({
                ...defaults,
                ...opts,
                particleCount: Math.floor(count * particleRatio)
              });
            }

            fire(0.25, {
              spread: 26,
              startVelocity: 55,
            });
            fire(0.2, {
              spread: 60,
            });
            fire(0.35, {
              spread: 100,
              decay: 0.91,
              scalar: 0.8
            });
            fire(0.1, {
              spread: 120,
              startVelocity: 25,
              decay: 0.92,
              scalar: 1.2
            });
            fire(0.1, {
              spread: 120,
              startVelocity: 45,
            });
          }
          return;
        case 'snow':
          if (window.confetti) {
            var duration = 15 * 1000;
            var animationEnd = Date.now() + duration;
            var skew = 1;

            (function frame() {
              var timeLeft = animationEnd - Date.now();
              var ticks = Math.max(200, 500 * (timeLeft / duration));
              skew = Math.max(0.8, skew - 0.001);

              confetti({
                particleCount: 1,
                startVelocity: 0,
                ticks: ticks,
                origin: {
                  x: Math.random(),
                  // since particles fall down, skew start toward the top
                  y: (Math.random() * skew) - 0.2
                },
                colors: [snow_color],
                shapes: ['circle'],
                gravity: randomInRange(0.4, 0.6),
                scalar: randomInRange(0.4, 1),
                drift: randomInRange(-0.4, 0.4)
              });

              if (timeLeft > 0) {
                requestAnimationFrame(frame);
              }
            }());
          }
          return;
        case 'snow_confetti':
            if (window.confetti) {
              var duration = 15 * 1000;
              var animationEnd = Date.now() + duration;
              var skew = 1;
  
              (function frame() {
                var timeLeft = animationEnd - Date.now();
                var ticks = Math.max(200, 500 * (timeLeft / duration));
                skew = Math.max(0.8, skew - 0.001);
  
                confetti({
                  particleCount: 1,
                  startVelocity: 0,
                  ticks: ticks,
                  origin: {
                    x: Math.random(),
                    // since particles fall down, skew start toward the top
                    y: (Math.random() * skew) - 0.2
                  },
                  colors: [snow_color],
                  shapes: ['circle'],
                  gravity: randomInRange(0.4, 0.6),
                  scalar: randomInRange(0.4, 1),
                  drift: randomInRange(-0.4, 0.4)
                });
  
                if (timeLeft > 0) {
                  requestAnimationFrame(frame);
                }
              }());
            }
            if (window.confetti) {
                var count = 200;
                var defaults = {
                  origin: { y: 0.7 }
                };
    
                function fire(particleRatio, opts) {
                  confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio)
                  });
                }
    
                fire(0.25, {
                  spread: 26,
                  startVelocity: 55,
                });
                fire(0.2, {
                  spread: 60,
                });
                fire(0.35, {
                  spread: 100,
                  decay: 0.91,
                  scalar: 0.8
                });
                fire(0.1, {
                  spread: 120,
                  startVelocity: 25,
                  decay: 0.92,
                  scalar: 1.2
                });
                fire(0.1, {
                  spread: 120,
                  startVelocity: 45,
                });
              }
            return;
          
          default:
          opts.particleCount = 50;
          opts.angle = 90;
          opts.spread = 45;
          opts.startVelocity = 45;
      }
});